import {
    loading
} from '@/common/loading';
import {
    getJgjcReportExamTask,
    getTaskList,
    checkLogin,
    getCaseCountNew,
} from '@/api/baseMsg';
export default {
    name: "jiageshenheListNew",
    data() {
        return {
            type: this.$route.query.type,
            // =========start======by wangry
            title: '国家数据上报',
            tableList: [],
            // active: 0,
            active: !Number(this.$route.query.active) ? 0 : Number(this.$route.query.active),
            startTime: '',
            endTime: '',
            // active2:  !Number(this.$route.query.active2)? 0: Number(this.$route.query.active2),
            active2: this.$route.query.active2 == 1 ? 1 : 0,
            loading1: false, //tabcard加载
            finished: false,
            todayCardList: [],//当日卡片列表
            allCardList: [],//全部卡片列表
            isBarNav: false,
            btnFlag: false,
            isBlue: 'blue2',//蓝色
            isGreen: 'green',//绿色
            isGrey: 'grey',//灰色
            isLoading: false,
            //===========end==========
            thisData: [],
            hbData: [],
            loginStatus: true,

            option1: [],
            option2: [],

            dscount: 0,//待审核

            // 2022-01-17新增
            dropdownTitle: "",//下拉展示标题
            dropdownInput: "",//搜索筛选框
            inputTable: [],//新数组作为筛选存储数组
            showDrop: false,//展示drop标记
            taskID: this.$route.query.taskID ? this.$route.query.taskID : '',
            stateId: this.$route.query.stateId ? this.$route.query.stateId : '',
        }
    },
    created() {
        this.init();
    },
    mounted() {
        window.addEventListener('scroll', this.scrollToTop);
    },
    destroyed() {
        window.removeEventListener('scroll', this.scrollToTop)
    },
    methods: {
        init() {
            loading(true);
            this.checkLogin();
            if (this.loginStatus) {
                this.getTaskNameList();
            }
        },
        // 获取任务列表
        getTaskNameList() {
            getTaskList().then(res => {
                this.tableList = [
                    {taskCode: "",
                    taskName: "全部"}
                ]
                this.inputTable = [
                    {taskCode: "",
                    taskName: "全部"}
                ]
                res.data.forEach(i=> {
                    this.tableList.push(i)
                    this.inputTable.push(i)
                })
                this.getCaseCount();
            })
        },
        //价格采集和价格审核数量
        getCaseCount() {
            getCaseCountNew({
                taskCode: this.taskCode,
            }).then(res => {
                this.dscount = res[1].unDonCount;//待审核数量
                this.getTodayCheckNew();
                this.getAllCheck();
            })
        }, 
        //价格审核 houcc 2021.04.09 当日任务
        getTodayCheckNew() {
            getJgjcReportExamTask({
                history: 0,
                taskCode: this.taskCode,
                pageSize: 1000,
                pageIndex: 1
            }).then(res => {
                this.todayCardList = res.data.list;
                this.dscount = Number(res.data.list.length) - Number(this.dscount)
                if(this.taskID && this.stateId) {
                    this.jump(this.taskID + this.stateId)
                }
                loading(false);
            })
        },
        jump(value){
            this.$nextTick(() => {
                setTimeout(() => {
                    document.getElementById(value).scrollIntoView({ behavior: "instant",block: "center", });
                })
            })
        },
        //全部任务
        getAllCheck() {
            loading(true)
            getJgjcReportExamTask({
                history: 1,
                taskCode: this.taskCode,
                pageSize: 1000,
                pageIndex: 1
            }).then(res => {
                this.allCardList = res.data.list;
                loading(false);
            })
        },
        toList(item) {//跳转  价格采集页面
            this.$router.push({
                path: '/cityReportxiangqing',
                query: {
                    periodNumber: item.periodNumber,
                    taskId: item.taskId,
                    periodSJNumber: item.periodSJNumber,
                    sjExeno: item.sjExeno,
                    sjtaskCode: item.sjtaskCode,
                    sjtaskName: item.sjtaskName,
                    gjTaskName: item.gjTaskName,
                    active2: this.active2,
                }
            });
        },
        navSwitch() {
            this.isBarNav = !this.isBarNav
        },

        //置顶图标
        backTop() {
            const that = this
            const timer = setInterval(() => {
                const ispeed = Math.floor(-that.scrollTop / 5)
                document.documentElement.scrollTop = document.body.scrollTop = that.scrollTop + ispeed
                if (that.scrollTop === 0) {
                    clearInterval(timer)
                }
            }, 16)
        },
        // 为了计算距离顶部的高度，当高度大于130显示回顶部图标，小于130则隐藏
        scrollToTop() {
            const that = this
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
            that.scrollTop = scrollTop
            that.btnFlag = that.scrollTop > 130;
            // that.isBarNav = that.scrollTop > 10;
        },
        onRefresh() {
            setTimeout(() => {
                this.isLoading = false;
                this.init();
            }, 300);
        },
        onClickLeft() {
            this.$router.push({
                path: '/',
            });
        },
        search() {
            this.getAllCheck();
        },
        onLoad() { //tabcard加载函数
            // 异步更新数据
            // setTimeout 仅做示例，真实场景中一般为 ajax 请求
            setTimeout(() => {
                // 加载状态结束
                this.loading1 = false;
                this.finished = true;
            }, 1000);
        },
        //监测登陆状态 houcc 2021.07.24
        checkLogin() {
            checkLogin({}).then(res => {
                if (!res.success) {
                    // nativeJSBridge.logout();
                    this.$router.push({ path: '/loginOld' });
                }
                this.loginStatus = res.success;
            })
        },

        fuzzyQuery(keyWord) {//搜索筛选方法
            if (keyWord.length == 0) {
                this.inputTable = this.tableList;
                return
            }
            const arr = [];
            for (let i = 0; i < this.tableList.length; i++) {
                if (this.tableList[i].taskName.indexOf(keyWord) >= 0) {
                    arr.push(this.tableList[i]);
                }
            }
            this.inputTable = arr;
        },
        dropClick(code, name) {
            //选择下拉列表点击事件
            this.dropdownInput = name;
            this.showDrop = !this.showDrop;
            // this.$refs.drop.toggle();
            this.taskCode = code;
            if (this.active === 0) {
                this.getCaseCount();
            } else if (this.active === 1) {
                this.getAllCheck();
            }
        },
        hideTabs() {//隐藏展示滚动tabs
            this.fuzzyQuery(this.dropdownInput);
            this.showDrop = true;
        },
        showTabs() {//展示滚动tabs
            this.showDrop = false;
        }
    },
    watch: {
        $route() {
            this.type = this.$route.query.type;
        },
    }
}